/**
 * PDF Security utilities for protecting documents
 */

export const pdfSecurityUtils = {
  /**
   * Initialize security measures for the entire document
   */
  initDocumentSecurity() {
    // Disable right-click context menu
    document.addEventListener("contextmenu", this.preventContextMenu);

    // Disable text selection
    document.addEventListener("selectstart", this.preventSelection);

    // Disable keyboard shortcuts
    document.addEventListener("keydown", this.preventKeyboardShortcuts);

    // Disable copy/cut events
    document.addEventListener("copy", this.preventCopy);
    document.addEventListener("cut", this.preventCut);

    // Override print function
    this.overridePrint();

    // Detect DevTools
    this.detectDevTools();
  },

  /**
   * Remove security measures (for cleanup)
   */
  removeDocumentSecurity() {
    document.removeEventListener("contextmenu", this.preventContextMenu);
    document.removeEventListener("selectstart", this.preventSelection);
    document.removeEventListener("keydown", this.preventKeyboardShortcuts);
    document.removeEventListener("copy", this.preventCopy);
    document.removeEventListener("cut", this.preventCut);
  },

  preventContextMenu(e) {
    e.preventDefault();
    return false;
  },

  preventSelection(e) {
    e.preventDefault();
    return false;
  },

  preventCopy(e) {
    e.clipboardData.setData("text/plain", "Copying is disabled");
    e.preventDefault();
    return false;
  },

  preventCut(e) {
    e.preventDefault();
    return false;
  },

  preventKeyboardShortcuts(e) {
    // Block Print (Ctrl+P / Cmd+P)
    if ((e.ctrlKey || e.metaKey) && e.key === "p") {
      e.preventDefault();
      console.warn("Printing is disabled for security reasons");
      return false;
    }

    // Block Save (Ctrl+S / Cmd+S)
    if ((e.ctrlKey || e.metaKey) && e.key === "s") {
      e.preventDefault();
      console.warn("Saving is disabled for security reasons");
      return false;
    }

    // Block Select All (Ctrl+A / Cmd+A)
    if ((e.ctrlKey || e.metaKey) && e.key === "a") {
      e.preventDefault();
      return false;
    }

    // Block Copy (Ctrl+C / Cmd+C)
    if ((e.ctrlKey || e.metaKey) && e.key === "c") {
      e.preventDefault();
      return false;
    }

    // Block F12 (DevTools)
    if (e.key === "F12" || e.keyCode === 123) {
      e.preventDefault();
      return false;
    }

    // Block Ctrl+Shift+I / Cmd+Option+I (DevTools)
    if (
      (e.ctrlKey && e.shiftKey && e.key === "I") ||
      (e.metaKey && e.altKey && e.key === "I")
    ) {
      e.preventDefault();
      return false;
    }

    // Block Ctrl+Shift+J / Cmd+Option+J (Console)
    if (
      (e.ctrlKey && e.shiftKey && e.key === "J") ||
      (e.metaKey && e.altKey && e.key === "J")
    ) {
      e.preventDefault();
      return false;
    }

    // Block Ctrl+Shift+C / Cmd+Option+C (Inspect)
    if (
      (e.ctrlKey && e.shiftKey && e.key === "C") ||
      (e.metaKey && e.altKey && e.key === "C")
    ) {
      e.preventDefault();
      return false;
    }
  },

  overridePrint() {
    window.print = function() {
      console.warn("Printing is disabled for security reasons");
      return false;
    };
  },

  detectDevTools() {
    let devtools = { open: false };
    const threshold = 160;

    setInterval(function() {
      if (
        window.outerHeight - window.innerHeight > threshold ||
        window.outerWidth - window.innerWidth > threshold
      ) {
        if (!devtools.open) {
          devtools.open = true;
          console.clear();
          console.warn(
            "%cSecurity Warning!",
            "color: red; font-size: 30px; font-weight: bold;"
          );
          console.warn(
            "%cDeveloper tools detected. Content protection is active.",
            "color: red; font-size: 16px;"
          );
          console.warn(
            "%cAny attempt to bypass security measures is prohibited.",
            "color: red; font-size: 16px;"
          );
        }
      } else {
        devtools.open = false;
      }
    }, 500);
  },

  /**
   * Generate watermark configuration based on document type and user data
   */
  getWatermarkConfig(userData) {
    const baseConfig = {
      text: userData.fullName || "CONFIDENTIAL",
      subtext: userData.userName || "",
      fontSize: 24,
      fontFamily: "Arial, sans-serif",
      color: "rgba(255, 0, 0, 0.1)",
      backgroundColor: "rgba(255, 255, 255, 0.1)",
      rotation: -45,
      spacing: 200,
      showTimestamp: true,
      showUserInfo: true,
      borderWatermark: true,
    };

    return baseConfig;
  },

  /**
   * Apply security CSS styles
   */
  applySecurityStyles(element) {
    if (!element) return;

    const styles = {
      "user-select": "none",
      "-webkit-user-select": "none",
      "-moz-user-select": "none",
      "-ms-user-select": "none",
      "-webkit-user-drag": "none",
      "-khtml-user-drag": "none",
      "-moz-user-drag": "none",
      "-o-user-drag": "none",
      "-webkit-touch-callout": "none",
      "-webkit-tap-highlight-color": "transparent",
    };

    Object.assign(element.style, styles);
  },
};

export default pdfSecurityUtils;
